<script>
export default {
  props: {
    input: {
      type: String,
      default: () => ''
    },
    field: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    inputData: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      // data: '',
      other: '',
      otherIsSelect: false,
      din: 0,
      co: 0
    }
  },
  computed: {
    data() {
      return `${this.din}丁 ${this.co}口`;
    },
  },
  watch: {
    inputData: {
      handler(v, ov) {
        this.setFromData()
      },
      deep: true
    },
    data: {
      handler(v, ov) {
        this.$emit('update:inputData', v)
      },
      deep: true
    },
  },
  mounted() {
    this.setFromData();
  },
  methods: {
    setFromData() {
      this.$nextTick(() => {
        // this.data = this.inputData;
      });
    },
    changeCity() {
      this.district = null;
    }
  },
  inject: ['$validator'],
}

</script>
<template>
  <div>
    <b-field
      class="is-style-extrafield-address"
    >
      <b-field
        :message="errors.first(name)"
        :type="{ 'is-danger': errors.has(name) }"
        :class="{ [$style['isRequired']]: field.required }"
        :label="`${field.title}`"
      >
        <div>
          <div class="columns">
            <div class="column">
              <b-select
                v-model="din"
                class="has-radius-danger"
                data-vv-as=""
                placeholder="請選擇丁數"
                :name="`${field.id}_${field.alias}_din`"
              >
                <option
                  :value="0"
                >
                  請選擇丁數
                </option>
                <option
                  v-for="(n, index) in 14"
                  :key="`${index}din`"
                  :value="n"
                >
                  {{n}}丁
                </option>
              </b-select>
            </div>
            <div class="column">
              <b-select
                v-model="co"
                class="has-radius-danger"
                data-vv-as=""
                placeholder="請選擇口數"
                :name="`${field.id}_${field.alias}_co`"
              >
                <option
                  :value="0"
                >
                  請選擇口數
                </option>
                <option
                  v-for="(n, index) in 14"
                  :key="`${index}co`"
                  :value="n"
                >
                  {{n}}口
                </option>
              </b-select>
            </div>
          </div>
        </div>
      </b-field>
    </b-field>
  </div>
</template>
<style lang="scss" module>
  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }
</style>
